// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__DAdN5","top":"styles_top__2BUwY","left":"styles_left__3bW37","description":"styles_description__EZ1FF"};